import { SupportedIdHolderDtoIn, SupportedIsraeliIdChangeImpactDtoIn } from '@/models/in/SupportedIsraeliIdChangeImpactDtoIn';

/** Why the server will refuse this ID change - see IsraeliIdChangeBlockerMessage for what the office reads. */
export type IsraeliIdChangeBlocker =
  | { kind: 'representative'; fundIds: number[] }
  | { kind: 'taken'; holder: SupportedIdHolderDtoIn };

/**
 * What stands in the way of the change, or null when nothing does: a coordinator's own card added
 * as a supported, or a new ID someone already holds. Office-only - the coordinator is never told
 * who holds a number.
 *
 * A taken number is a stop, not a procedure. If the two cards are the same person the right fix is
 * merging them, which the system does not do (Chaya, 19.10: a task of its own, not needed now).
 */
export const israeliIdChangeBlocker = (impact: SupportedIsraeliIdChangeImpactDtoIn): IsraeliIdChangeBlocker | null => {
  if (impact.representedFundIds.length > 0) {
    return { kind: 'representative', fundIds: impact.representedFundIds };
  }
  if (impact.newIdHolder) {
    return { kind: 'taken', holder: impact.newIdHolder };
  }
  return null;
};

/**
 * The supported on the office's supporteds screen, in a new tab: the table narrowed to that one row
 * (with its edit and «הסר מפרויקט») and its details blade open. Opened from inside a dialog, so the
 * dialog the office is in stays where it is.
 */
export const managementSupportedHref = (contactId: number) => `/new/management/supporteds?resourceId=${contactId}`;
